"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BaseSubscriptionService = _interopRequireDefault(require("./BaseSubscriptionService"));
var _apex = _interopRequireDefault(require("../../apex"));
var _store = _interopRequireDefault(require("../../redux/store"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Level1SubscriptionService = /*#__PURE__*/function (_BaseSubscriptionServ) {
  function Level1SubscriptionService() {
    _classCallCheck(this, Level1SubscriptionService);
    return _callSuper(this, Level1SubscriptionService, arguments);
  }
  _inherits(Level1SubscriptionService, _BaseSubscriptionServ);
  return _createClass(Level1SubscriptionService, [{
    key: "initSubscription",
    value: function initSubscription(instrumentId) {
      if (this.subscription) {
        this.unsubscribe();
      }
      return _apex["default"].connection.RPCPromise('SubscribeLevel1', {
        instrumentId: instrumentId,
        OMSId: 1
      }).then(function (res) {
        var data = JSON.parse(res.o);
        if (data.result === false) throw data;
        return data;
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      this.unsubscribe();
      this.subscription = _apex["default"].connection.ws.filter(function (x) {
        return x.n === 'Level1UpdateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }

    /**
     * Stop getting updates from server for all instruments
     */
  }, {
    key: "stop",
    value: function stop() {
      var instruments = _store["default"].getState().apexCore.instrument.instruments;
      instruments.forEach(function (_ref) {
        var InstrumentId = _ref.InstrumentId;
        _apex["default"].connection.unsubscribeLevel1(InstrumentId);
      });
    }
  }, {
    key: "stopOne",
    value: function stopOne(instrumentId) {
      _apex["default"].connection.unsubscribeLevel1(instrumentId);
    }
  }]);
}(_BaseSubscriptionService["default"]);
var _default = exports["default"] = new Level1SubscriptionService();